import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Button } from "primereact/button";
import {
  redirectTo,
  ssoErrorMessageId,
  ssoStartUrl,
} from "../../../helpers/SsoHelper";
import { RouteConstants } from "../../../constants";
import PreLoginContainer from "../../common/preLoginContainer";
import Link from "../../common/link";

// /sso/error?reason=...: a plain message for each reason; the technical
// reason is in the audit log only.
export const SsoError = ({ enterprise }) => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const messageId = ssoErrorMessageId(searchParams.get("reason"));

  return (
    <PreLoginContainer>
      <div className="title text-center">
        {intl.formatMessage({ id: "sso_error_title" })}
      </div>
      <div className="flex flex-column gap-3 align-items-center mt-4">
        <div className="error-message text-center">
          {intl.formatMessage({ id: messageId })}
        </div>
        {(enterprise?.ssoEnabled && enterprise?.subDomain && (
          <Button
            type="button"
            className="w-full"
            onClick={() => redirectTo(ssoStartUrl(enterprise.subDomain))}
          >
            <div className="gap-2 flex justify-content-center w-full">
              <span>{intl.formatMessage({ id: "sso_try_again" })}</span>
              <i className="pi pi-arrow-right"></i>
            </div>
          </Button>
        )) ||
          null}
        <Link to={RouteConstants.APP_ROUTE_LOGIN}>
          {intl.formatMessage({ id: "back_to_login" })}
        </Link>
      </div>
    </PreLoginContainer>
  );
};

const mapStateToProps = (state) => ({
  enterprise: state.global?.enterprise,
});

export default connect(mapStateToProps)(SsoError);
